import React, {useEffect, useReducer, useContext, useState} from 'react'
import ComponentSelector from '../ComponentSelector'
import {
    Stepper,
    Step,
    StepLabel,
    StepButton,
    Typography,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    Grid,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Dialog,
    DialogContentText,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {ToastContext} from '../../App'
import ConfirmationBox from '../ConfirmationBox'
import i18next from 'i18next'
import StepIcon from '../StepIcon'
import {
    validateMilestone,
    getClientEnrollmentStatus,
    getMyAccountURL,
} from '../../services/milestoneValidation'
import Loader from '../Loader'
import {TOAST_VARIANT} from '../../utils/constants'
import MarkdownRender from '../MarkdownRender'

const GetStepContent = props => {
    const activeStep = props.steps.filter(p => p.order === props.activeStep)
    const sections = activeStep[0].sections
    if (
        sections[0].componentType === 'Payment' ||
        sections[0].componentType === 'Reporting'
    ) {
        return <ComponentSelector {...sections[0]} />
    } else if (sections[0].componentType === 'EDDetails') {
        return (
            <ComponentSelector
                getSectionState={props.getSectionState}
                updateSectionState={props.updateSectionState}
                {...sections[0]}
                loggedInUserData={props.loggedInUserData}
                sections={sections}
                enrollmentStatus={props.enrollmentStatus}
                navigateMilestoneSteps={props.navigateMilestoneSteps}
            />
        )
    }
    return (
        <>
            {sections.map((obj, index) => {
                return (
                    <ExpansionPanel
                        key={obj.sectionname}
                        expanded={props.getSectionState(obj.sectionname)}
                        onChange={() => props.updateSectionState(obj.sectionname)}
                        className="accordion_master-wrapper"
                        // TransitionProps={{unmountOnExit: true}}
                    >
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1c-content"
                            id="panel1c-header"
                            className="accordion_master-header__wrapper"
                        >
                            <Grid className="accordion_master__header ">
                                {obj.icon && (
                                    <FontAwesomeIcon
                                        icon={['fal', obj.icon]}
                                    ></FontAwesomeIcon>
                                )}
                                <Typography variant="h5" className="accordion_title_h5">
                                    {obj.sectionname}
                                </Typography>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="accordion_master-content__wrapper ">
                            <Grid container className="accordion_master-content__row">
                                <Grid item xs className="accordion_master-content__grid">
                                    <ComponentSelector
                                        {...obj}
                                        loggedInUserData={props.loggedInUserData}
                                        enrollmentStatus={props.enrollmentStatus}
                                        navigateMilestoneSteps={
                                            props.navigateMilestoneSteps
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                )
            })}
        </>
    )
}

export const MilestoneContext = React.createContext()
export const MilestoneSectionContext = React.createContext()

const reducer = (state, action) => {
    switch (action.type) {
        case 'set':
            return {...state, ...action.payload}
        case 'setSectionMsg':
            return {...state, sectionMsg: {...state.sectionMsg, ...action.payload}}
        default:
            return state
    }
}

const sectionFormReducer = (state, action) => {
    switch (action.type) {
        case 'setsectionformdatachanged':
            const addSection = [...state]
            addSection.push(action.payload)
            return addSection
        case 'removesectionformdatachanged':
            return []
        default:
            return state
    }
}

const Milestone = props => {
    const {showToast} = useContext(ToastContext)
    const [validation, dispatch] = useReducer(reducer, {})
    const [sectionFormState, setDataChanged] = useReducer(sectionFormReducer, [])
    const [steps, setSteps] = useState(props.steps)
    const [sectionState, setSectionState] = useState([])
    const [openCofirmation, setOpenCofirmation] = useState(false)
    const [currentStep, setCurrentStep] = useState({})
    const [loading, setloading] = useState(false)
    const [isOpen, setOpen] = useState(false)
    const [redirect, setredirect] = useState(false)
    const [enrollmentStatus, setenrollmentStatus] = useState(false)
    const [myaccountredirecturl, setMyaccountRedirectURL] = useState('')
    const showMilestone = sessionStorage.getItem('milestone') === 'false' ? false : true
    const [disabledClink, setDisabledClink] = useState(true)

    const enabledDisabledMilestone = action => {
        setDisabledClink(action === 'disabled' ? true : false)
    }
    useEffect(() => {
        if (validation !== {}) {
            let sectionsObj = []
            Object.keys(validation).map(sectionName => {
                if (sectionName !== 'sectionMsg') {
                    sectionsObj.push(sectionName)
                    return sectionName
                }
            })
            let isValid = true
            sectionsObj.forEach(sec => {
                if (validation[[sec]] === null) {
                    isValid = false
                    return
                }
            })
            if (isValid) enabledDisabledMilestone('enabled')
            else enabledDisabledMilestone('disabled')
        } else enabledDisabledMilestone('disabled')
    }, [validation])

    useEffect(() => {
        enabledDisabledMilestone('disabled')
        const sectionsArr = []
        steps.forEach(element => {
            element.sections.forEach(element => {
                const obj = {name: element.sectionname, isExpanded: true}
                sectionsArr.push(obj)
            })
        })
        setSectionState(sectionsArr)
        const callApi = async () => {
            const response = await getMyAccountURL()
            setMyaccountRedirectURL(response.url)
        }
        callApi()
        const enrollmentFlagAPI = async () => {
            const enrollmentFlag = await getClientEnrollmentStatus()
            setenrollmentStatus(enrollmentFlag)
        }
        enrollmentFlagAPI()
    }, [])

    useEffect(() => {
        const activeStep = props.steps.filter(p => p.order === props.activeStep)
        document.title = activeStep[0].label
    }, [props.activeStep])

    const updateSectionState = key => {
        const updatedSectionState = sectionState.map(p => {
            if (p.name === key) p.isExpanded = !p.isExpanded
            return p
        })
        setSectionState([...new Set([...sectionState, ...updatedSectionState])])
    }

    const displayMilestoneValiationApiMsgHelper = (response, step) => {
        const milestoneDetails = response.error ? response.error.validations || [] : []
        const milestoneid = []
        let activeStep = 0
        steps.forEach(element => {
            if (element.active) activeStep = element.order
            if (element.order < step.order + 1) milestoneid.push(element.label)
        })
        const incompleteMilestones = []
        const incompleteSections = []
        const incompleteActiveMilestoneSections = []
        const incompleteSectionDetails = {}
        let extraMessage = null
        let currentMilestoneSction = false
        milestoneid.forEach((p, i) => {
            if (activeStep === i) currentMilestoneSction = true
            else currentMilestoneSction = false
            const milestoneObj = milestoneDetails.filter(q => q.milestonename === p)
            const milestoneSection =
                milestoneObj.length > 0 ? milestoneObj[0].sections || [] : []
            milestoneSection.forEach(s => {
                if (s.hasOwnProperty('isgroupvalidated') && !s.isgroupvalidated) {
                    extraMessage =
                        props.validationMessages.groupValidation ||
                        'You need to add atleast 2 clinicians to report as Group.'
                } else {
                    if (s.validations.length > 0 || s.recordexists === false) {
                        if (currentMilestoneSction) {
                            incompleteActiveMilestoneSections.push(s.sectionname)
                        }
                        incompleteSections.push(s.sectionname)
                        incompleteSectionDetails[s.sectionname] = s.validations.map(
                            p => p.message
                        )
                        if (
                            incompleteMilestones.indexOf(
                                milestoneObj[0].milestonename
                            ) === -1
                        )
                            incompleteMilestones.push(milestoneObj[0].milestonename)
                    }
                }
            })
        })
        if (incompleteSections.length === 0) {
            if (extraMessage != null) {
                showToast({
                    open: true,
                    variant: TOAST_VARIANT.ERROR,
                    message: extraMessage,
                })
                enabledDisabledMilestone('enabled')
            } else if (step.order === props.steps.length - 1) {
                const callApi = async () => {
                    const enrollmentFlag = await getClientEnrollmentStatus()
                    setenrollmentStatus(enrollmentFlag)
                    props.handleStep(step.order)
                }
                callApi()
            } else {
                props.handleStep(step.order)
            }
        } else if (incompleteActiveMilestoneSections.length > 0) {
            displayMilestoneValiationMsgHelper(
                incompleteActiveMilestoneSections,
                extraMessage
            )
            enabledDisabledMilestone('enabled')
        } else if (incompleteMilestones.length > 2) {
            const lastMilestone = incompleteMilestones.pop()
            let msg = `${i18next.t(
                'milestone.validation.incompleted_section_Msg'
            )}${incompleteMilestones.join(', ')} and ${lastMilestone} milestones.`

            showToast({
                open: true,
                variant: TOAST_VARIANT.ERROR,
                message:
                    extraMessage && extraMessage != null
                        ? orderList(msg, extraMessage)
                        : msg,
                isHTML: extraMessage && extraMessage != null,
            })
            enabledDisabledMilestone('enabled')
        } else if (incompleteMilestones.length === 2) {
            const lastMilestone = incompleteMilestones.pop()
            let msg = `${i18next.t(
                'milestone.validation.incompleted_section_Msg'
            )}${incompleteMilestones.join(', ')} and ${lastMilestone} milestones.`

            showToast({
                open: true,
                variant: TOAST_VARIANT.ERROR,
                message:
                    extraMessage && extraMessage != null
                        ? orderList(msg, extraMessage)
                        : msg,
                isHTML: extraMessage && extraMessage != null,
            })
            enabledDisabledMilestone('enabled')
        } else {
            let msg = `${i18next.t(
                'milestone.validation.incompleted_section_Msg'
            )}${incompleteMilestones.join(', ')} milestone.`
            showToast({
                open: true,
                variant: TOAST_VARIANT.ERROR,
                message:
                    extraMessage && extraMessage != null
                        ? orderList(msg, extraMessage)
                        : msg,
                isHTML: extraMessage && extraMessage != null,
            })
            enabledDisabledMilestone('enabled')
        }
    }

    const orderList = (val1, val2) => {
        return `<ol><li>${val1}</li><li>${val2}</li></ol>`
    }
    const displayMilestoneValiationMsgHelper = (inCompletedSections, extraMessage) => {
        const milestoneName = steps.filter(p => p.order === props.activeStep)[0].label
        if (
            (inCompletedSections.length === 1 || inCompletedSections.length > 1) &&
            milestoneName === 'Technical Survey' &&
            validation.sectionMsg[inCompletedSections[0]] !== ''
        ) {
            showToast({
                open: true,
                variant: TOAST_VARIANT.ERROR,
                message:
                    extraMessage && extraMessage != null
                        ? orderList(
                              validation.sectionMsg[inCompletedSections[0]],
                              extraMessage
                          )
                        : validation.sectionMsg[inCompletedSections[0]],
                isHTML: extraMessage && extraMessage != null,
            })
            return
        }
        if (
            inCompletedSections.length === 1 &&
            milestoneName === 'Agreements' &&
            validation.sectionMsg[inCompletedSections[0]] !== ''
        ) {
            showToast({
                open: true,
                variant: TOAST_VARIANT.ERROR,
                message:
                    extraMessage && extraMessage != null
                        ? orderList(
                              validation.sectionMsg[inCompletedSections[0]],
                              extraMessage
                          )
                        : validation.sectionMsg[inCompletedSections[0]],
                isHTML: extraMessage && extraMessage != null,
            })
            return
        }
        if (
            inCompletedSections.length === 1 &&
            validation.sectionMsg[inCompletedSections[0]]
        ) {
            showToast({
                open: true,
                variant: TOAST_VARIANT.ERROR,
                message:
                    extraMessage && extraMessage != null
                        ? orderList(
                              validation.sectionMsg[inCompletedSections[0]],
                              extraMessage
                          )
                        : validation.sectionMsg[inCompletedSections[0]],
                isHTML: extraMessage && extraMessage != null,
            })
        } else {
            let msg = ''
            if (inCompletedSections.length > 2) {
                const lastsection = inCompletedSections.pop()
                msg = `Few of the required details are missing in the ${inCompletedSections.join(
                    ', '
                )} and ${lastsection} sections.`
            } else if (inCompletedSections.length === 1)
                msg = `Few of the required details are missing in the ${inCompletedSections.join(
                    ', '
                )} section.`
            else
                msg = `Few of the required details are missing in the ${inCompletedSections.join(
                    ' and '
                )} sections.`
            showToast({
                open: true,
                variant: TOAST_VARIANT.ERROR,
                message:
                    extraMessage && extraMessage != null
                        ? orderList(msg, extraMessage)
                        : msg,
                isHTML: extraMessage && extraMessage != null,
            })
        }
    }

    const getSectionState = key => {
        const obj = sectionState.filter(p => p.name === key)
        if (obj[0]) return obj[0].isExpanded
        return true
    }

    const validateActiveMilestone = () => {
        let checkKey = steps
            .filter(p => p.order === props.activeStep)[0]
            .sections.map(s => s.sectionname)
        const currentActivestep = steps.filter(p => p.order === props.activeStep)[0]
        const innerSections =
            currentActivestep.sections[0].mastersectiondetails[0].jsonschema
                .sectionsDetails_TechnicalSurvey
        if (Array.isArray(innerSections)) {
            innerSections.forEach(p => {
                if (p.section_validation_name !== undefined) {
                    if (checkKey.indexOf(p.section_validation_name) === -1) {
                        if (p.checkTableEntries === false)
                            console.log(p.section_validation_name)
                        else checkKey.push(p.section_validation_name)
                    }
                }
            })
        }
        let inCompletedSections = []
        checkKey.forEach(element => {
            if (
                !validation[element] &&
                validation[element] !== undefined &&
                inCompletedSections.indexOf(element) === -1
            ) {
                inCompletedSections.push(element)
            }
        })
        return inCompletedSections
    }

    const handleVirtualMilestone = step => {
        // const activeStep = step
        const inputStep = step.clientprogrammilestoneOrder + 1
        const callApi = async () => {
            setloading(true)
            if (enrollmentStatus) {
                setloading(false)
                window.location.replace(myaccountredirecturl)
                return
            }
            const enrollmentFlag = await getClientEnrollmentStatus()
            setenrollmentStatus(enrollmentFlag)
            if (enrollmentFlag) {
                setloading(false)
                window.location.replace(myaccountredirecturl)
                return
            }
            const response = await validateMilestone(inputStep)
            setloading(false)
            if (response.enrollmentcomplete === true) {
                setredirect(true)
                setOpen(true)
                return
            } else if (response.enrollmentcomplete === false) {
                showToast({
                    open: true,
                    variant: TOAST_VARIANT.ERROR,
                    message: 'Something went wrong.',
                })
                return
            }

            if (response.error) {
                if (response.error.message) {
                    showToast({
                        open: true,
                        variant: TOAST_VARIANT.ERROR,
                        message: `${response.error.message}`,
                    })
                    return
                }
            }
            console.log('val =2')
            displayMilestoneValiationApiMsgHelper(response, step)
        }
        callApi()
    }

    const verifyMileStoneValResponse = step => {
        if (step.virtualmilestone) {
            handleVirtualMilestone(step)
            return
        }
        const callApi = async () => {
            setloading(true)
            const response = await validateMilestone(step.clientprogrammilestoneOrder)
            setloading(false)
            if (response.error.message) {
                showToast({
                    open: true,
                    variant: TOAST_VARIANT.ERROR,
                    message: `${response.error.message}`,
                })
                return
            }
            console.log('val =3')
            displayMilestoneValiationApiMsgHelper(response, step)
        }
        callApi()
    }

    const onStepClick = step => {
        if (step.order === props.activeStep) return
        if (sectionFormState.length > 0) {
            setOpenCofirmation(true)
            setCurrentStep(step)
        } else if (step.order < props.activeStep) {
            enabledDisabledMilestone('disabled')
            props.handleStep(step.order)
        } else {
            const inCompletedSections = validateActiveMilestone()
            if (inCompletedSections.length === 0) {
                enabledDisabledMilestone('disabled')
                verifyMileStoneValResponse(step)
            } else displayMilestoneValiationMsgHelper(inCompletedSections)
        }
    }

    const navigateStep = () => {
        const step = {...currentStep}
        if (step.order < props.activeStep) {
            enabledDisabledMilestone('disabled')
            props.handleStep(step.order)
        } else {
            const inCompletedSections = validateActiveMilestone()
            if (inCompletedSections.length === 0) {
                enabledDisabledMilestone('disabled')
                verifyMileStoneValResponse(step)
            } else displayMilestoneValiationMsgHelper(inCompletedSections)
        }
        setCurrentStep({})
        removeMilestoneFormDataChanged()
        setOpenCofirmation(false)
    }

    const confirmAction = () => {
        setCurrentStep({})
        setOpenCofirmation(false)
    }

    const updateValidation = (tabName, value) =>
        dispatch({type: 'set', payload: {[tabName]: value}})

    const updateValidationMsg = (tabName, value) =>
        dispatch({type: 'setSectionMsg', payload: {[tabName]: value}})

    const setMilestoneFormDataChanged = tabName =>
        setDataChanged({type: 'setsectionformdatachanged', payload: tabName})

    const removeMilestoneFormDataChanged = tabName =>
        setDataChanged({type: 'removesectionformdatachanged', payload: tabName})

    const navigateMilestoneSteps = direction => {
        if (direction === 'finish') {
            const inCompletedSections = validateActiveMilestone()
            if (inCompletedSections.length !== 0) {
                displayMilestoneValiationMsgHelper(inCompletedSections)
                return
            }
            const activeStep = props.steps.filter(p => p.order === props.activeStep)
            const inputStep = activeStep[0].clientprogrammilestoneOrder + 1

            const callApi = async () => {
                setloading(true)
                if (enrollmentStatus) {
                    setloading(false)
                    window.location.replace(myaccountredirecturl)
                    return
                }
                const enrollmentFlag = await getClientEnrollmentStatus()
                setenrollmentStatus(enrollmentFlag)
                if (enrollmentFlag) {
                    setloading(false)
                    window.location.replace(myaccountredirecturl)
                    return
                }
                const response = await validateMilestone(inputStep)

                setloading(false)
                if (response.enrollmentcomplete === true) {
                    setOpen(true)
                    return
                } else if (response.enrollmentcomplete === false) {
                    showToast({
                        open: true,
                        variant: TOAST_VARIANT.ERROR,
                        message: 'Something went wrong.',
                    })
                    return
                }

                if (response.error) {
                    if (response.error.message) {
                        showToast({
                            open: true,
                            variant: TOAST_VARIANT.ERROR,
                            message: `${response.error.message}`,
                        })
                        return
                    }
                }
                console.log('val =1')
                displayMilestoneValiationApiMsgHelper(response, activeStep[0])
            }
            callApi()
            return
        }
        const reqStep =
            direction === 'forward'
                ? props.steps.filter(p => p.order === props.activeStep + 1)[0]
                : props.steps.filter(p => p.order === props.activeStep - 1)[0]
        if (sectionFormState.length > 0) {
            setOpenCofirmation(true)
            setCurrentStep(reqStep)
        } else if (direction === 'forward') {
            const inCompletedSections = validateActiveMilestone()
            if (inCompletedSections.length === 0) {
                enabledDisabledMilestone('disabled')
                verifyMileStoneValResponse(reqStep)
            } else displayMilestoneValiationMsgHelper(inCompletedSections)
        } else {
            enabledDisabledMilestone('disabled')
            props.handleStep(reqStep.order)
        }
    }

    const currentSteporder = props.activeStep === props.steps.length - 1

    const handleSignupComplete = () => {
        if (redirect) {
            window.location.replace(myaccountredirecturl)
        }
        setenrollmentStatus(true)
        setOpen(false)
    }
    return (
        <MilestoneSectionContext.Provider
            value={{
                sectionFormState,
                setMilestoneFormDataChanged,
                removeMilestoneFormDataChanged,
            }}
        >
            <MilestoneContext.Provider
                value={{validation, updateValidation, updateValidationMsg}}
            >
                {loading && <Loader type="center-overlay" />}
                <Grid item xs className="signup-milestone-main__wrapper">
                    {showMilestone && (
                        <Grid container className="milestone-stepper__wrapper-row">
                            <Stepper
                                className="milestone-stepper__wrapper"
                                nonLinear
                                activeStep={props.activeStep}
                                alternativeLabel
                            >
                                {steps.map(step => {
                                    return (
                                        <Step key={step.label}>
                                            <StepButton
                                                onClick={() => onStepClick(step)}
                                                className="milestone-stepper__btn"
                                                completed={step.order < props.activeStep}
                                                disabled={disabledClink}
                                            >
                                                <StepLabel
                                                    StepIconComponent={StepIcon}
                                                    className="milestone-stepper__btn-icon"
                                                >
                                                    {step.label}
                                                </StepLabel>
                                            </StepButton>
                                        </Step>
                                    )
                                })}
                            </Stepper>
                        </Grid>
                    )}
                    <Grid item xs={12} className="milestone-message-wrapper">
                        <MarkdownRender value={props.mileStoneTopMessage} />
                    </Grid>
                    <Grid container className="milestone-page-content__wrapper">
                        <Grid
                            item
                            xs={12}
                            className="milestone-page-main-content__container"
                        >
                            <GetStepContent
                                {...props}
                                getSectionState={getSectionState}
                                updateSectionState={updateSectionState}
                                enrollmentStatus={enrollmentStatus}
                                navigateMilestoneSteps={navigateMilestoneSteps}
                            />
                        </Grid>

                        {showMilestone && (
                            <Grid
                                item
                                xs={12}
                                className="milestone-page-footer__container"
                            >
                                {props.steps && props.steps.length > 1 && (
                                    <Button
                                        variant="outlined"
                                        disabled={props.activeStep === 0 || disabledClink}
                                        color="primary"
                                        onClick={() => navigateMilestoneSteps('back')}
                                        className="previous-btn"
                                    >
                                        Previous
                                    </Button>
                                )}
                                {!currentSteporder && (
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        disabled={currentSteporder || disabledClink}
                                        onClick={() => navigateMilestoneSteps('forward')}
                                        className="next-btn"
                                    >
                                        Next
                                    </Button>
                                )}
                                {currentSteporder && !enrollmentStatus && (
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        disabled={disabledClink}
                                        onClick={() => navigateMilestoneSteps('finish')}
                                        className="next-btn"
                                    >
                                        Finish
                                    </Button>
                                )}
                                {currentSteporder && enrollmentStatus && (
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        disabled={disabledClink}
                                        onClick={() =>
                                            window.location.replace(myaccountredirecturl)
                                        }
                                        className="next-btn"
                                    >
                                        Go to My Account
                                    </Button>
                                )}
                            </Grid>
                        )}
                        <Grid>
                            {openCofirmation && (
                                <ConfirmationBox
                                    open={openCofirmation}
                                    closeDialog={navigateStep}
                                    confirmAction={confirmAction}
                                    message={i18next.t(
                                        'milestone.formChanged.confirmationModal.message'
                                    )}
                                    confirmButton={i18next.t(
                                        'milestone.formChanged.confirmationModal.confirmButton'
                                    )}
                                    rejectButton={i18next.t(
                                        'milestone.formChanged.confirmationModal.rejectButton'
                                    )}
                                />
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                {isOpen && (
                    <Dialog
                        open={isOpen}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            <MarkdownRender
                                value={
                                    props.enrollmentMsg
                                        ? props.enrollmentMsg
                                        : i18next.t('sign_up_completion_msg')
                                }
                            />
                        </DialogTitle>
                        <DialogActions>
                            <Button onClick={handleSignupComplete} color="primary">
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </MilestoneContext.Provider>
        </MilestoneSectionContext.Provider>
    )
}

export default Milestone
